import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { ApiService } from './api.service';
import { AuthService } from './auth.service';

@Injectable()
export class BoldBiService {

    constructor(
        public authService: AuthService,
        public apiService: ApiService
    ) { }

    public create(boldBi:any, authToken:string, dashboard_Id:string, embedContainerId:string, filterParameters:string, width:any = "100%", height:any = "100%"):any {
        var session_token = this.authService.getActive().session_token;
        return boldBi.create({
            serverUrl: environment.bi_url + environment.bi_site_url,
            dashboardId: dashboard_Id,
            embedContainerId: embedContainerId,
            embedType: boldBi.EmbedType.Component,
            environment: boldBi.Environment.Enterprise,
			mode: boldBi.Mode.View,
            width: width,
            height: height,
            theme: boldBi.Theme.Dark,
            expirationTime:100000,
            dashboardSettings: {
                enableFullScreen: false,
                showDashboardParameter: false,
                enableFilterOverview: false,
                autoRefreshSettings: {
                    enabled: false
                }
            },
            authorizationServer: {
				url: environment.service_url + environment.bi_auth_Url + "?ot=" + authToken,
            },
            filterParameters: filterParameters,
            autoRefreshSettings: {
                enabled: true,
                hourlySchedule: {
                    hours: 0,
                    minutes: 10,
                    seconds: 0
                }
            },
            actionBegin:"emdbedDashboardActionBegin",
            actionComplete:"emdbedDashboardActionComplete"
        });
    }
}



// WEBPACK FOOTER //
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/services/bold-bi.service.ts